import { BuilderState } from './model/builder-state.model';

const stateWrapper: {
    builderState: BuilderState | null;
} = {
    builderState: null,
};

export const currentBuilderState = (): BuilderState =>
    stateWrapper.builderState;

export const defaultBuilderState = (): void => {
    stateWrapper.builderState = {
        viewParams: {},
        viewParamLabels: {},
    };
};
